<article
  class="v3-content-card"
  [class.v3-content-card--list]="isList()"
  [class.v3-content-card--accent-teal]="item().accent === 'teal'"
  [attr.data-card-uid]="item().uid"
>
  @if (!editActions()) {
    <button type="button" class="v3-content-card__main-link" [attr.aria-label]="item().title" (click)="onCardClick()"></button>
  }

  <div class="v3-content-card__cover" [class.has-save]="showSave()" [style.background]="coverBackground()">
    @if (hasThumbnail()) {
      <img class="v3-content-card__cover-image" [src]="item().thumbnail" [alt]="item().title" />
    } @else if (item().coverIcon) {
      <span class="v3-content-card__cover-icon" aria-hidden="true">
        <svg [lucideIcon]="item().coverIcon!" [size]="20"></svg>
      </span>
    }
    @if (!isList() && item().typeLabel) {
      <span class="v3-content-card__type-chip">
        @if (item().typeIcon) {
          <svg [lucideIcon]="item().typeIcon!" [size]="12"></svg>
        }
        {{ item().typeLabel }}
      </span>
    }
    @if (showSave()) {
      <button
        type="button"
        class="v3-content-card__save"
        [class.is-saved]="saved()"
        [attr.aria-label]="saveLabel() || null"
        [attr.aria-pressed]="saved()"
        (click)="onSaveClick()"
      >
        <svg [lucideIcon]="LucideBookmark" [size]="16"></svg>
      </button>
    }
    @if (editActions()) {
      <span class="v3-content-card__edit-actions">
        <button
          type="button"
          class="v3-content-card__edit-btn"
          [attr.aria-label]="'translations.global.button.edit' | transloco"
          (click)="onEditClick()"
        >
          <svg [lucideIcon]="LucidePencil" [size]="14"></svg>
        </button>
        @if (deletable()) {
          <button
            type="button"
            class="v3-content-card__edit-btn v3-content-card__edit-btn--delete"
            [attr.aria-label]="'translations.global.button.remove' | transloco"
            (click)="onDeleteClick()"
          >
            <svg [lucideIcon]="LucideTrash2" [size]="14"></svg>
          </button>
        }
      </span>
    }
  </div>

  <div class="v3-content-card__body">
    @if (showBadgeRow()) {
      <div class="v3-content-card__badges">
        @if (isList() && item().typeLabel) {
          <span class="v3-content-card__type-badge">
            @if (item().typeIcon) {
              <svg [lucideIcon]="item().typeIcon!" [size]="12"></svg>
            }
            {{ item().typeLabel }}
          </span>
        }
        @if (item().statusBadge; as badge) {
          <span class="v3-content-card__status-badge" [attr.data-tone]="badge.tone">
            @if (badge.icon) {
              <svg [lucideIcon]="badge.icon" [size]="11"></svg>
            }
            {{ badge.label }}
          </span>
        }
      </div>
    }

    <h3 class="v3-content-card__title" [class.is-placeholder]="item().titleIsPlaceholder">{{ item().title }}</h3>

    @if (item().subtitle) {
      <div class="v3-content-card__subtitle">{{ item().subtitle }}</div>
    }

    @if (metaEntries().length) {
      <div class="v3-content-card__meta">
        @for (entry of metaEntries(); track $index) {
          <span class="v3-content-card__meta-item">
            @if (entry.icon) {
              <svg [lucideIcon]="entry.icon" [size]="11"></svg>
            }
            {{ entry.text }}
          </span>
        }
      </div>
    }

    @if (!isList() && tags().length) {
      <div class="v3-content-card__tags">
        @for (tag of tags().slice(0, 2); track $index) {
          <span class="v3-content-card__tag">{{ tag }}</span>
        }
      </div>
    }

    @if (!compact()) {
      @if (gradeLabel(); as grade) {
        <div class="v3-content-card__progress v3-content-card__grade">
          <span
            class="v3-content-card__grade-pill"
            [class.v3-content-card__grade-pill--pass]="gradePassing()"
            [class.v3-content-card__grade-pill--fail]="!gradePassing()"
          >
            <svg [lucideIcon]="gradeIcon()" [size]="12"></svg>
            {{ grade }}
          </span>
        </div>
      } @else if (hasProgress()) {
        <div class="v3-content-card__progress">
          <div class="v3-content-card__progress-bar-bg">
            <div class="v3-content-card__progress-bar-fill" [style.width.%]="progressValue()"></div>
          </div>
          <span class="v3-content-card__progress-text">{{ progressValue() }}%{{ progressSuffix() }}</span>
        </div>
      } @else if (!isList() && reserveRowSpace()) {
        <div class="v3-content-card__progress v3-content-card__progress--empty"></div>
      }
    }
  </div>

  @if (!compact()) {
    @if (action(); as cardAction) {
      <span class="v3-content-card__action">
        <ptl-button
          [type]="cardAction.type"
          size="s"
          [text]="cardAction.label"
          [fullWidth]="!isList()"
          (clicked)="onActionClick()"
        ></ptl-button>
      </span>
    } @else if (!isList() && reserveRowSpace() && reserveActionSpace()) {
      <span class="v3-content-card__action v3-content-card__action--empty" aria-hidden="true">
        <ptl-button type="primary" size="s" text="placeholder" [fullWidth]="true"></ptl-button>
      </span>
    }
  }
</article>
